import {Stack} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import { IsdsMessageInfoDto } from "../../../client/message/IsdsMessageApiClient";
import { DateTimeFormatter } from "../../../common/DateTimeFormatter";
import {DetailsTable} from "../../../common/details/DetailsTable";
import {DetailsTextRow} from "../../../common/details/DetailsTextRow";
import {MessageTranslKey} from "../MessageTranslKey";
import {MessageStatusFormatter} from "../MessageStatusFormatter";

export interface MessageInfoPanelProps {
    message: IsdsMessageInfoDto;
}

export default function MessageInfoPanel(props: Readonly<MessageInfoPanelProps>) {
    const {message} = props;

    const {t} = useTranslation();
    const createTime = DateTimeFormatter.formatDateTime(message.createTime);
    const nextTryAfter = DateTimeFormatter.formatDateTime(message.nextTryAfter);

    return (
        <Stack spacing={2} padding={1}>
            <DetailsTable>
                <tbody>
                <DetailsTextRow label={t(MessageTranslKey.ID)}
                                value={message.id}/>

                <DetailsTextRow label={t(MessageTranslKey.PRIORITY)}
                                value={message.priority}/>

                <DetailsTextRow label={t(MessageTranslKey.CREATE_TIME)}
                                value={createTime ?? undefined}/>

                <DetailsTextRow label={t(MessageTranslKey.CURRENT_STATE)}
                                value={MessageStatusFormatter.formatMessageStatusStatus(message.currentState?.type, t)}/>

                <DetailsTextRow label={t(MessageTranslKey.NEXT_TRY_AFTER)}
                                value={nextTryAfter ?? undefined}/>

                <DetailsTextRow label={t(MessageTranslKey.ERROR_COUNT)}
                                value={message.errorCount !== undefined ? message.errorCount.toString() : undefined}/>

                <DetailsTextRow label={t(MessageTranslKey.RECIPIENT)}
                                value={message.recipient}/>

                <DetailsTextRow label={t(MessageTranslKey.ANNOTATION)}
                                value={message.annotation}/>
                </tbody>
            </DetailsTable>
        </Stack>
    );
}
